import { Button } from './Button';
import { CameraLayers } from '../../enum/CameraLayers';

declare const THREE: any;

export class ObjectResizeControls extends (THREE.Object3D as { new(): any; }) {

  constructor() {
    super();
    const verticalResizeTexture = new THREE.TextureLoader().load('assets/images/sprites/size_grip.png');
    const horizontalResizeTexture = new THREE.TextureLoader().load('assets/images/sprites/size_grip_horizontal.png');
    const top = new Button(verticalResizeTexture, 'top', CameraLayers.VERTICAL_RESIZE);
    const bottom = new Button(verticalResizeTexture, 'bottom', CameraLayers.VERTICAL_RESIZE);
    const left = new Button(horizontalResizeTexture, 'left', CameraLayers.HORIZONTAL_RESIZE);
    const right = new Button(horizontalResizeTexture, 'right', CameraLayers.HORIZONTAL_RESIZE);
    this.add(top);
    this.add(bottom);
    this.add(left);
    this.add(right);
    this.visible = false;
    this.name = 'resizeControls';
  }

  update(object) {
    const sprites = this.children;
    const {length, height} = object.userData.entity;
    object.getWorldPosition(this.position);
    object.getWorldQuaternion(this.quaternion);
    sprites[0].position.y = height / 2;
    sprites[1].position.y = -height / 2;
    sprites[2].position.x = -length / 2;
    sprites[3].position.x = length / 2;
  }

}



// WEBPACK FOOTER //
// ./src/app/custom/Controls/ObjectResizeControls.ts